import React, { useEffect } from "react";

import { useForm } from "react-hook-form";

import { IMarketingGroup } from "../../models/marketingGroup/MarketingGroup";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import Flyout, { FlyoutControlProps } from "../../containers/Flyout";
import { StyledTextInput } from "../Shared/StyledInputs/StyledTextInput";
import StyledSwitchInput from "../Shared/StyledInputs/StyledSwitchInput";
import { useMarketingGroupMutations } from "../../data/marketingGroup/useMarketingGroupMutations";

interface CreateMarketingGroupFlyoutProps extends FlyoutControlProps { }

export function CreateMarketingGroupFlyout({ open, setOpen }: CreateMarketingGroupFlyoutProps) {
  const { create } = useMarketingGroupMutations();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<IMarketingGroup>({
    defaultValues: { name: "", active: false }
  });

  const onSubmit = (data: IMarketingGroup) => {
    create.mutate(data, { onSuccess: () => setOpen(false) });
  }

  useEffect(() => {
    reset({ name: "", active: false });
  }, [reset]);

  return (
    <Flyout open={open} setOpen={setOpen} title="Create Marketing Group">
      <div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <StyledTextInput
            label="Name"
            register={register}
            registerName="name"
            registerOptions={{ required: "Name is required" }}
          />
          <StyledSwitchInput
            label="Active"
            register={register}
            registerName="active"
            setValue={setValue}
            watch={watch}
            classes="flex items-end"
          />
          <div className="mt-6 sm:col-span-2">
            <ButtonInput
              isSubmit={true}
              label="Create Marketing Group"
              onClick={undefined}
              children={undefined}
              classes={undefined}
            />
          </div>
        </form>
      </div>
    </Flyout>
  )
}